// const API_BASE_URL = 'http://localhost:3000'
const API_BASE_URL = 'https://employee-server.pbq.co.ir'

export default {
    getApiBaseUrl: () => {
        return API_BASE_URL
    },
}
